import { Formik } from 'formik';
import { FC, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { FormContainer } from 'src/components/form/form-container';
import { NetworkPointSelect } from 'src/components/form/select/network-point-select/network-point-select';
import { useAxios } from 'src/hooks/use-axios';
import { NetworkPointDetail } from 'src/types/monolith';

type FormValues = {
  networkPoint?: { label: string; value: string };
};

type Props = {
  initialOpen?: boolean;
  initialSearch?: string;
};

export const NetworkPointSearchNew: FC<Props> = ({
  initialOpen,
  initialSearch,
}) => {
  const { push } = useHistory();
  const oldNetworkPoint = useNetworkPointByUuid();

  useEffect(() => {
    if (!oldNetworkPoint.response) return;
    push(
      `/platform/#/network-point/details/${oldNetworkPoint.response.data.id}`
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [oldNetworkPoint.response]);

  return (
    <Formik<FormValues>
      initialValues={{ networkPoint: undefined }}
      onSubmit={(values, helpers) => {
        if (values.networkPoint?.value) {
          oldNetworkPoint.execute(values.networkPoint.value);
          helpers.setFieldValue('networkPoint', undefined);
        }
      }}
    >
      {({ submitForm }) => (
        <FormContainer mode="regular">
          <NetworkPointSelect
            name="networkPoint"
            label="Network Point"
            placeholder="Find a Network Point"
            hideLabel
            mode="search"
            onChange={submitForm}
            pending={oldNetworkPoint.pending}
            initialOpen={initialOpen}
            initialSearch={initialSearch}
          />
        </FormContainer>
      )}
    </Formik>
  );
};

function useNetworkPointByUuid() {
  return useAxios(
    (axios, signal, uuid: string) =>
      axios.request<NetworkPointDetail>({
        signal,
        url: `${PRISMA_CONFIG.oldBackendUrl}/networkPoints/by-uuid/${uuid}`,
      }),
    { neededOnPageLoad: false }
  );
}
